/* Design tokens copied from the Soomuch one-pager source. */

export const FONT_SANS = "'Plus Jakarta Sans', system-ui, sans-serif";
export const FONT_BODY = "'Plus Jakarta Sans', sans-serif";
export const FONT_HAND = "'Caveat', cursive";

export const C = {
  ink: '#0F172A',
  navy: '#0F2D6B',
  navyHover: '#1E3A8A',
  primary: '#2563EB',
  primaryHover: '#1D4ED8',
  sky: '#60A5FA',
  indigoSoft: '#818CF8',
  slate: '#334155',
  muted: '#475569',
  gray: '#64748B',
  faint: '#94A3B8',
  green: '#16A34A',
  greenBg: '#ECFDF3',
  greenSoft: '#E7F8EF',
  red: '#DC2626',
  redBorder: '#F87171',
  amber: '#EA8C1A',
  amberBg: '#FFF8E8',
  amberSoft: '#FEF3E4',
  pink: '#DB2777',
  pinkBg: '#FCE9F3',
  teal: '#0D9488',
  tealBg: '#E5F7F4',
  violet: '#6366F1',
  violetBg: '#EEF0FE',
  blueBg: '#EFF6FF',
  blueSoft: '#E8F0FE',
  bluePale: '#E0EDFF',
  ice: '#F5F9FE',
  iceBright: '#F4F8FE',
  iceBlue: '#F3F8FF',
  mist: '#F7FAFF',
  card: '#FBFDFF',
  cardEdge: '#FCFDFF',
  border: '#E7EEF9',
  borderSoft: '#E3EBF7',
  borderPale: '#EDF3FC',
  hairline: '#F1F6FD',
  inputBorder: '#CFDFF6',
  statDivider: '#CFE1FA',
  chipBlueBox: '#D6E6FB',
  white: '#fff',
} as const;

export const LOGO_SRC = '/images/onepager-logo.svg';
